import React, { FC, useCallback } from 'react';
import { OperatorProps } from '../../../../@types/TemplateOperators';
import { ArgsInput, ArgsSelect } from './BasicComponents';
import { getColumnDropDownOptions, validateColumnInitValue } from './utils';

export enum AppendModes {
  APPEND = 'APPEND',
  APPEND_TO = 'APPEND_TO'
}

const PrependCases = [
  { label: 'APPEND', value: 'APPEND' },
  { label: 'APPEND_TO', value: 'APPEND_TO' }
];

const Append: FC<OperatorProps> = ({ step, handleArgsChange, dropDownOptions }) => {
  const [appendMode, defaultValue] = step.args;

  const options = getColumnDropDownOptions(dropDownOptions);
  const columnInitialValue = validateColumnInitValue(defaultValue, options.length);

  const modeChangeHandler = useCallback(
    (value: string | number): void => {
      handleArgsChange([value]);
    },
    [handleArgsChange]
  );

  const argsChangeHandler = useCallback(
    (value: string | number): void => {
      handleArgsChange([appendMode, value]);
    },
    [handleArgsChange, appendMode]
  );

  return (
    <div data-testid="append-operator">
      <div className="flex mt-6 w-1/2">
        <ArgsSelect
          argsSelectLabel="mode"
          options={PrependCases}
          onChange={modeChangeHandler}
          value={appendMode || ''}
          label="Append to some field, or append value from previous step"
        />
      </div>
      {appendMode === AppendModes.APPEND && (
        <div className="flex mt-6 w-1/2">
          <ArgsInput
            initialValue={defaultValue || ''}
            onChange={argsChangeHandler}
            label="append"
            subLabel="Value to be appended"
          />
        </div>
      )}
      {appendMode === AppendModes.APPEND_TO && (
        <div className="flex my-6 w-1/2">
          <ArgsSelect
            argsSelectLabel="column"
            options={options}
            onChange={argsChangeHandler}
            value={columnInitialValue}
            label="Column to append value to"
            maxVisible={2}
          />
        </div>
      )}
    </div>
  );
};

export default Append;
